<template>
  <v-card class="pa-4">
    <v-card-title class="product-edit-dialog__close pa-0">
      <v-btn
        icon
        depressed
        fixed
        class="product-edit-dialog__close__btn"
        @click="onClose"
      >
        <v-icon
          small
          color="rgba(20, 12, 34, 0.25)"
        >
          mdi-window-close
        </v-icon>
      </v-btn>
    </v-card-title>

    <ProductInfos
      v-if="product"
      :product="product"
      :store="store"
    />

    <v-card-actions
      class="pa-0 mx-0 mt-4 justify-center"
    >
      <v-btn
        outline
        depressed
        color="#140C22"
        class="product-edit-dialog__cancel"
        @click="onClose"
      >
        Cancelar
      </v-btn>
      <v-btn
        dark
        depressed
        color="#140C22"
        class="product-edit-dialog__confirm"
        @click="confirmEdit"
      >
        Confirmar alteração
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ProductInfos from './ProductInfos.vue';

export default {
  components: {
    ProductInfos,
  },

  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    store: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    onClose() {
      this.$emit('close');
    },
    confirmEdit() {
      if (this.product.modification && this.product.modification === 'zeroStock') {
        delete this.product.modification;
      }
      this.onClose();
    },
  },
};
</script>

<style scoped lang="scss">
%dialog-action-btn {
  font-weight: 600;
  font-size: 12px;
  line-height: 10px;
  text-transform: none;
  height: 32px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
}

.product-edit-dialog {
  font-family: 'Nunito Sans';
  &__close {
    display: flex;
    justify-content: end;
    &__btn {
      z-index: 10;
      margin: 10px 0 0;
      height: fit-content;
      width: fit-content;
    }
  }
  &__cancel {
    @extend %dialog-action-btn;
    max-width: 108px;
  }
  &__confirm {
    @extend %dialog-action-btn;
    max-width: 164px;
  }
}
</style>
